<script setup lang="ts">

import { onMounted, ref } from "vue";
import { useUserSettings } from "@services/UserSettings";
import { useUser } from "@domain/Security";
import { useCheckIfUserHasSwitchedApp } from "./Dealership/SetHomeDealership/useCheckIfUserHasSwitchedApp";
import { useViewModelInstance } from "..";
import { Profile, Conditions } from "../Components";
import { isDevelopment } from "@modules/Utilities/Environments";
import { resetRequestedMarketplaceCategory } from "@app/MyMarketplace/Types/useRequestMarketplaceCategory";

import "./MyGarage.scss";

// Get the view model instance, this can be used on any page as long as the required
// route parameters are present
const user = useUser();
let model = await useViewModelInstance();

const isReady = ref( false );
const showDebug = isDevelopment();

// Set the navigation controls
onMounted( () =>
{

    model.onMounted();

    isReady.value = true;

    if( model.showConnectToHealthMonitorWorkflow == false )
    {
        useCheckIfUserHasSwitchedApp();

        // If we came here from the marketplace, remove any requested category from local storage
        resetRequestedMarketplaceCategory();
    }

} );

</script>

<template>

    <!-- THERE WAS A PROBLEM GETTING THE PAGE READY -->
    <div v-if="isReady == false"
        class="p-6 text-lg">
        There was a problem, please try again later
    </div>

    <!-- OTHERWISE WE CAN DISPLAY THE MYGARAGE PAGE -->
    <div v-else
        class="flex flex-col items-center text-lg w-full h-full">

        <transition name="fade" mode="out-in">

            <div v-keep-scroll="{ key: 'vehicle-panel' }"
                class="flex flex-col w-full h-full items-start overflow-y-auto absolute top-0"
                :class="{
                    'pt-10': user.isDealerMode
                }">

                <Profile v-model="model" />

                <div v-if="model.carePlan.showReminders"
                     class="flex flex-col w-full items-start">
                    <Conditions v-model="model" />
                </div>

                <div class="flex w-full justify-center pb-12"
                     :class="{ 'mt-6': model.carePlan.showReminders == false }">
                    <RouterLink v-if="showDebug"
                                to="/debug"
                                class="flex items-center text-purple-500">
                        <Icon name="debug" class="text-3xl 3xl:text-4xl mr-1 lg:mr-1.5" />
                        <span class="3xl:text-base font-bold uppercase">Debug</span>
                    </RouterLink>
                </div>

            </div>

        </transition>

    </div>

</template>
